import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import DynamicBackground from './components/DynamicBackground';
import { Form, Input, Button, Checkbox, message, Select, Space } from 'antd'
import { MobileOutlined, LockOutlined } from '@ant-design/icons';
import { login } from '../../api/login'
import { AxiosResponse, AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { ApiResponse } from '../../types';
import type { LoginInfo } from '../../types/user';
import type { FormProps } from 'antd';
import { sendSMS } from '../../api/common';
import AnimatedBackground from '../components/AnimatedBackground';
import Header from '../header';
import Logo from '../components/Logo';
import { Rule } from 'antd/es/form';
import { useTranslation } from 'react-i18next';


const LoginPage = () => {
  const [countdown, setCountdown] = useState<number>(0);
  const [agreement, setAgreement] = useState<boolean>(false);
  const [form] = Form.useForm();

  const navigate = useNavigate()
  const { t } = useTranslation();

  useEffect(() => {
    let timer: number;
    if (countdown > 0) {
      timer = window.setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [countdown]);


    const getPhoneValidationRules = (countryCode: string) => {
    const rules: Rule[] = [
        { required: true, message: '请输入手机号' }
    ];
    
    switch (countryCode) {
        case '+86':
            rules.push({ pattern: /^1[3456789]\d{9}$/, message: '请输入正确的中国手机号(11位数字，以1开头)' });
            break;
        case '+1':
            rules.push({ pattern: /^\d{10}$/, message: '请输入正确的美国手机号(10位数字)' });
            break;
        case '+84':
            rules.push({ pattern: /^[0-9]{9,10}$/, message: '请输入正确的越南手机号(9-10位数字)' });
            break;
        case '+62':
            rules.push({ pattern: /^[0-9]{9,12}$/, message: '请输入正确的印尼手机号(9-12位数字)' });
            break;
        case '+852':
            rules.push({ pattern: /^[0-9]{8}$/, message: '请输入正确的香港手机号(8位数字)' });
            break;
        case '+65':
            rules.push({ pattern: /^[0-9]{8}$/, message: '请输入正确的新加坡手机号(8位数字)' });
            break;
        case '+81':
            rules.push({ pattern: /^[0-9]{10,11}$/, message: '请输入正确的日本手机号(10-11位数字)' });
            break;
        case '+82':
            rules.push({ pattern: /^[0-9]{10,11}$/, message: '请输入正确的韩国手机号(10-11位数字)' });
            break;
        case '+91':
            rules.push({ pattern: /^[0-9]{10}$/, message: '请输入正确的印度手机号(10位数字)' });
            break;
        case '+44':
            rules.push({ pattern: /^[0-9]{10,11}$/, message: '请输入正确的英国手机号(10-11位数字)' });
            break;
        default:
            rules.push({ pattern: /^[0-9]{8,15}$/, message: '请输入正确的手机号' });
    }
    
    return rules;
};

  const sendVerificationCode = () => {
    const phoneNumber = form.getFieldValue('phone');
    const fullPhoneNumber = selectedCountryCode + phoneNumber;
    
    // 根据国家代码验证手机号
    const isValidPhone = (() => {
        if (!phoneNumber) return false;
        
        switch (selectedCountryCode) {
            case '+86':
                return /^1[3456789]\d{9}$/.test(phoneNumber);
            case '+1':
                return /^\d{10}$/.test(phoneNumber);
            case '+84':
                return /^[0-9]{9,10}$/.test(phoneNumber);
            case '+62':
                return /^[0-9]{9,12}$/.test(phoneNumber);
            case '+852':
                return /^[0-9]{8}$/.test(phoneNumber);
            case '+65':
                return /^[0-9]{8}$/.test(phoneNumber);
            case '+81':
                return /^[0-9]{10,11}$/.test(phoneNumber);
            case '+82':
                return /^[0-9]{10,11}$/.test(phoneNumber);
            case '+91':
                return /^[0-9]{10}$/.test(phoneNumber);
            case '+44':
                return /^[0-9]{10,11}$/.test(phoneNumber);
            default:
                return /^[0-9]{8,15}$/.test(phoneNumber);
        }
    })();
    
    if (isValidPhone) {
      console.log('Sending verification code to:', fullPhoneNumber);
      setCountdown(60);
      sendSMS({ 'phone': fullPhoneNumber, 'type': 1 }).then((res: AxiosResponse<ApiResponse>) => {
        if (res.data.status === 200) {
          message.success("验证码已发送")
        }
      }).catch(() => {
        setCountdown(0);
      })
    } else {
      form.setFields([
        {
          name: 'phone',
          errors: ['请输入正确的手机号'],
        },
      ]);
    }
  };

  const onFinish: FormProps['onFinish'] = (values) => {
    // 将国家代码和手机号组合
    const fullPhoneNumber = selectedCountryCode + values.phone;
    const loginData = {
        ...values,
        phone: fullPhoneNumber,
        countryCode: selectedCountryCode
    };

    login(loginData).then((res: AxiosResponse<ApiResponse<LoginInfo>>) => {
      if (res.data.status === 200) {
        var d = res.data.data
        localStorage.setItem('access_token', d.access_token);
        localStorage.setItem('refresh_token', d.refresh_token);
        navigate('/console/home')
      } else if (res.data.status === 1004) {
        message.error("验证码错误")
      } else if (res.data.status === 1005) {
        message.error("用户无效")
      } else if (res.data.status === 1006) {
        message.error("网络连接故障，请稍后再试")
      }
    }).catch((err: AxiosError) => message.error("网络连接故障，请稍后再试"))
  };

  const [selectedCountryCode, setSelectedCountryCode] = useState('+86');
  const countryOptions = [
    { code: '+86', name: '中国', flag: '🇨🇳', disabled: false },
    { code: '+1', name: '美国', flag: '🇺🇸', disabled: false },
    { code: '+44', name: '英国', flag: '🇬🇧', disabled: false },
    { code: '+62', name: '印尼', flag: '🇮🇩', disabled: false },
    { code: '+65', name: '新加坡', flag: '🇸🇬', disabled: false },
    { code: '+81', name: '日本', flag: '🇯🇵', disabled: false },
    { code: '+82', name: '韩国', flag: '🇰🇷', disabled: false },
    { code: '+84', name: '越南', flag: '🇻🇳', disabled: false },
    { code: '+852', name: '香港', flag: '🇭🇰', disabled: false },
  ];

  return (
    <>
      <div className={styles.logo}>
        <Logo />
      </div>

      <div className={styles.loginPage}>
        <DynamicBackground />

        <div className={styles.loginContainer}>
          <div className={styles.loginHeader}>
            <h1>{t('login_text')}</h1>
            <div className={styles.aiIcon}></div>
          </div>

          <Form
            form={form}
            name="mobile_login"
            className={styles.loginForm}
            onFinish={onFinish}
          >
            <Form.Item
              name="phone"
              rules={getPhoneValidationRules(selectedCountryCode)}
            >
              <Space.Compact className={styles.compact}>
                <Select
                  prefix={<MobileOutlined className={styles.inputIcon} />}
                  value={selectedCountryCode}
                  onChange={setSelectedCountryCode}
                  className={styles.countrySelect}
                  size="large"
                >
                  {countryOptions.map(country => (
                    <Select.Option
                      key={country.code}
                      value={country.code}
                      disabled={country.disabled}
                    >
                      <span className={styles.flag}>{country.flag}</span>
                      {country.code}
                    </Select.Option>
                  ))}
                </Select>
                <Input

                  placeholder={t('login.input_placehoder')}
                  className={styles.inputBox}
                  size="large"
                />
              </Space.Compact>
            </Form.Item>

            <Form.Item
              name="smsCode"
              rules={[{ required: true, message: t('login.input_code') }]}
            >
              <Input
                prefix={<LockOutlined className={styles.inputIcon} />}
                placeholder={t('login.input_code')}
                suffix={
                  <Button
                    className={styles.codeButton}
                    disabled={countdown > 0}
                    onClick={sendVerificationCode}
                    size="small"
                  >
                    {countdown > 0 ? `${countdown}s` : t('login.send_smscode')}
                  </Button>
                }
                size="large"
              />
            </Form.Item>

            <Form.Item
              name="agreement"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(new Error('请同意隐私条款')),
                },
              ]}
            >
              <Checkbox><div className={styles.policy}>{t('login.policy_prompt')} <a href="/privacy_policy.html" target="_blank">{t('login.policy_text')}</a></div></Checkbox>
            </Form.Item>

            <Form.Item>
              <Button htmlType="submit" className={styles.loginButton} size="large" type="primary">
                {t('login_text')}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </>
  );
};

export default LoginPage;